import { AppointmentStatusCodes } from '@lmt/shared-types';
import { OptionProps } from '@lmt/unicorn-shared/app/components/common/ui-kit/buttons/IconDropDownButton';
import React, { FC, ReactNode } from 'react';
import { CaseTreeItemType, TransportInfo } from '../../types';
import { AddDataBlockButton } from './AddDataBlockButton';
import { VisitStatusOption } from './VisitStatusOption';
import styles from './CaseTreeItem.module.scss';
import { TransportStatusOption } from './TransportStatusOption';

export type ItemProps = {
  id: string;
  navId?: string;
  onClick?: (id: string) => void;
  title: string;
  subtitle?: ReactNode;
  isHeader?: boolean;
  isSubitem: boolean;
  isLastElement: boolean;
  isLastBranch: boolean;
} & (
  | {
      type: CaseTreeItemType.addContent;
      options: OptionProps[];
    }
  | {
      type: CaseTreeItemType.showStatus;
      options: AppointmentStatusCodes;
    }
  | {
      type: CaseTreeItemType.empty;
      options: any;
    }
  | {
      type: CaseTreeItemType.transportStatus;
      options: TransportInfo;
    }
);

export const CaseTreeItem: FC<ItemProps> = (props) => {
  const {
    id,
    navId,
    onClick,
    isHeader,
    title,
    subtitle,
    type,
    options,
    isLastElement,
    isSubitem,
    isLastBranch,
  } = props;

  return (
    <div
      data-header={isHeader}
      className={styles.container}
      data-case-item-link={id}
      onClick={() => onClick?.(navId ?? id)}
      data-subitem={isSubitem}
      data-last={isLastElement}
      data-last-branch={isLastBranch}
      data-test-id={'case-content-item'}
    >
      <div className={styles.contentContainer}>
        <div className={styles.titleContainer}>
          <div
            className={styles.title}
            data-test-id={'case-content-item-title'}
          >
            <div className={styles.branch}>
              <div className={styles.verticalLine}>
                <div className={styles.topLine} />
                <div className={styles.bottomLine} />
              </div>
              <div className={styles.horizontalLine} />
            </div>
            {title}
          </div>
          <div className={styles.optionContainer}>
            {type === CaseTreeItemType.addContent && (
              <AddDataBlockButton options={options as OptionProps[]} />
            )}
            {type === CaseTreeItemType.showStatus && (
              <VisitStatusOption status={options as AppointmentStatusCodes} />
            )}
            {type === CaseTreeItemType.transportStatus && (
              <TransportStatusOption {...options} />
            )}
          </div>
        </div>
        <div
          className={styles.dateRange}
          data-test-id={'case-content-item-subtitle'}
        >
          {subtitle}
        </div>
        <div></div>
      </div>
    </div>
  );
};
